<script>
import ToolsGroup from 'components/common/ToolsGroup/index.vue'

const RIGHT_TOOLS = [
  {
    icon: 'icon-linkedin2',
    name: 'LinkedIn',
    link: 'https://www.linkedin.com/company/think-academy-international-education-hub/',
    target: '_blank',
    type: 'link',
  },
  {
    name: 'WhatsApp',
    icon: 'icon-whatsapp',
    link: 'https://wa.me/60126880646',
    target: '_blank',
    type: 'link',
    tip: '+60 12 688 0646',
  },
]

export default {
  name: 'MyCareerTools',
  extends: ToolsGroup,
  data() {
    return {
      tools: RIGHT_TOOLS,
    }
  },
}
</script>
